export default "__VITE_ASSET__CfTHh9ZG__"